// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","3479":"375ce8d6","5977":"375ce8d6","7983":"375ce8d6"}[chunkId] + ".chunk.css";
};